// extracted by mini-css-extract-plugin
export default {"reportingButton":"ReportingMenu_reportingButton__Cukyr","active":"ReportingMenu_active__i2tms"};